import skg from "./statementPDF/kg.json";
import sru from "./statementPDF/ru.json";
import sen from "./statementPDF/en.json";

export default {
  kg: skg,
  ru: sru,
  en: sen,
};
